import { getMinutes } from 'date-fns'
import PropTypes from 'prop-types'
import React from 'react'

const DateTick = ({ tick, count, format }) => {
    const isFullHour = !getMinutes(tick.value)

    const tickLabelStyle = {
        left: `${tick.percent}%`,
    }

    return (
        <>
            {isFullHour && (
                <div className='react_time_range__tick_label react_time_range__tick_date_label'
                     style={tickLabelStyle}
                >
                    {format(tick.value)}
                </div>
            )}
        </>
    )
}

DateTick.propTypes = {
    tick: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired
    }).isRequired,
    count: PropTypes.number.isRequired,
    format: PropTypes.func.isRequired
}

DateTick.defaultProps = {
    format: d => d
}

export default DateTick
